import axios from 'axios'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import flow from 'lodash/fp/flow'
import getFp from 'lodash/fp/get'
import mapFp from 'lodash/fp/map'

export default function dataToFormData(data) {
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    if (data[key] !== undefined && data[key] !== null) {
      formData.append(key, data[key])
    }
  })
  return formData
}

export const graphqlFetch = (data) =>
  axios({
    baseURL: '',
    url: '/graphql',
    method: 'post',
    headers: {
      accept: 'application/json',
    },
    data,
  })

export const getConnectionNodes = (connection) =>
  flow(getFp('edges'), mapFp('node'))(connection)

export const fetchMoreFromCollection = (
  data,
  fetchMore,
  path = '',
  cursorVariable = 'cursor'
) => {
  const {
    pageInfo: { endCursor },
  } = get(data, path)
  fetchMore({
    variables: {
      [cursorVariable]: endCursor,
    },
    updateQuery: (previousResult, { fetchMoreResult }) => {
      const { edges: previousEdges } = get(previousResult, path, {})
      const { edges: nextEdges, pageInfo: nextPageInfo } = get(
        fetchMoreResult,
        path,
        {}
      )
      const nextResult = cloneDeep(previousResult)
      set(nextResult, `${path}.pageInfo`, nextPageInfo)
      set(nextResult, `${path}.edges`, [...previousEdges, ...nextEdges])

      return nextEdges.length ? nextResult : previousResult
    },
  })
}
